import React, { useState } from 'react'
import { Content, ActivityName, Measuring, Distance, Duration, Unit } from './styles'
import { ActivitiesHistory } from '../../activities/ActivitiesHistory'
import { BehaviorCard } from '~/components/behaviors/BehaviorCard'
import { usePatient } from '~/context'
import { message } from '~/services'
import { toTrue, transformDate } from '~/utils'
import { IBehavior } from '~/interfaces'

interface IProps {
  behavior: IBehavior | undefined
}

const SHOW_HISTORY = true

export const Activities = ({ behavior }: IProps): JSX.Element => {
  const { patient } = usePatient()
  const [isActivityHistoryVisible, setIsActivityHistoryVisible] = useState(false)

  if (!behavior) return <></>
  if (behavior.type !== 'Exercício') return <></>

  const { endDate, properties } = behavior

  // TODO: tratar a renderização de campos sem valores
  const datetimeLastUpdate = transformDate({ date: endDate, withHourAndMinute: false, dateFormat: 'dd/MM HH:mm' })
  const activityName = properties.find(p => p.type === 'Tipo de Exercício')?.value
  const distance = properties.find(p => p.type === 'Distância')
  const duration = properties.find(p => p.type === 'Duração')

  const handleShowHistory = () => setIsActivityHistoryVisible(toTrue)

  return (
    <>
      <BehaviorCard
        title={message('behaviors.activities')}
        iconName="behaviorExercise"
        time={datetimeLastUpdate}
        showHistory={SHOW_HISTORY}
        onClickOpenHistory={handleShowHistory}
      >
        <Content>
          <ActivityName>{activityName}</ActivityName>
          <Measuring>
            <Distance>{distance?.value}</Distance>
            <Unit>{distance?.unit}</Unit>
          </Measuring>
          <Duration>{duration?.value}</Duration>
        </Content>
      </BehaviorCard>

      <ActivitiesHistory
        patientId={patient.id}
        show={isActivityHistoryVisible}
        setShowModal={setIsActivityHistoryVisible}
      />
    </>
  )
}
